import React, { Component } from 'react';
import cn from 'classnames';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
// eslint-disable-next-line import/first
import { withTranslation } from 'react-i18next';

const variants = {
  intoYard: {
    param: 'intoYard',
    key: 'intoYard',
    text: i18n.t('constants.view_type.filter.intoYard')
  },
  toMountains: {
    param: 'toMountains',
    key: 'toMountains',
    text: i18n.t('constants.view_type.filter.toMountains')
  },
  onSea: {
    param: 'onSea',
    key: 'onSea',
    text: i18n.t('constants.view_type.filter.onSea')
  },
  toPark: {
    param: 'toPark',
    key: 'toPark',
    text: i18n.t('constants.view_type.filter.toPark')
  },
  toGarden: {
    param: 'toGarden',
    key: 'toGarden',
    text: i18n.t('constants.view_type.filter.toGarden')
  },
  toForest: {
    param: 'toForest',
    key: 'toForest',
    text: i18n.t('constants.view_type.filter.toForest')
  },
  onSocialObjects: {
    param: 'onSocialObjects',
    key: 'onSocialObjects',
    text: i18n.t('constants.view_type.filter.onSocialObjects')
  },
  panoramicView: {
    param: 'panoramicView',
    key: 'panoramicView',
    text: i18n.t('constants.view_type.filter.panoramicView')
  }
};

const defaultViewTypes = {
  intoYard: false,
  toMountains: false,
  onSea: false,
  toPark: false,
  toGarden: false,
  toForest: false,
  onSocialObjects: false,
  panoramicView: false
};

// ////////////////////////////

export const parseSearch = (search) => {
  const { view_type } = search;

  if (!view_type) {
    return { view_type: [] };
  }
  const keys = view_type.split(',');
  return {
    view_type: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { view_type: keys } = data;
  if (!keys || !keys.length) {
    return { view_type: undefined };
  }

  return {
    view_type: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { view_type } = data;
  return { view_type: view_type.length ? view_type : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { view_type: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.viewTypes.notSelected');
};

class ViewTypes extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.calculateList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.calculateList();
  }

  calculateList = () => {
    if (!this.props.chessfilter) {
      return;
    }

    this.list = this.props.cells.reduce(
      (list, cell) => cell.data.view_type ? list.add(cell.data.view_type) : list,
      (new Set())
    );
  }

  handleClearClick() {
    const { search, dropdownData } = this.props;
    const { view_type } = parseSearch(search);

    const data = { view_type: defaultViewTypes };
    const compiledSearch = compileSearch(data);

    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick(Object.keys(view_type));
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const { view_type: keys } = parseSearch(search);
    const view_type = [...keys];

    if (eventData) {
      tracker.sendVariantEvent({ variants, key, selected: add, eventData });
    }

    if (!view_type.includes(key)) {
      view_type.push(key);
    } else {
      view_type.splice(view_type.indexOf(key), 1);
    }

    const data = { view_type };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);

    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    if (this.props.chessfilter && !this.list.has(key)) {
      return null;
    }

    const { search, additional } = this.props;
    const { view_type } = parseSearch(search);

    const variant = variants[key];

    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={view_type.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { view_type } = parseSearch(search);
    const isViewTypesDefined = !!view_type.length;

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <div className={styles.Title}>
          <span>{t('components.header.filtersBar.filters.viewTypes.title')}</span>
          {!additional ? (
            isViewTypesDefined &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.viewTypes.clear')}
            </Button>
          ) : (null)}
        </div>
        <div
          className={cn(styles.Checkboxes, {
            [styles.CheckboxesInChess]: this.props.chessfilter
          })}
        >
          {this.checkbox('intoYard')}
          {this.checkbox('toMountains')}
          {this.checkbox('onSea')}
          {this.checkbox('toPark')}
          {this.checkbox('toGarden')}
          {this.checkbox('toForest')}
          {this.checkbox('onSocialObjects')}
          {this.checkbox('panoramicView')}
        </div>

        {additional ? (
          <div className={styles.ButtonWrap}>
            {isViewTypesDefined &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.viewTypes.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation()(ViewTypes);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/ViewType/ViewType.jsx